import React, { useContext, useEffect, useRef, useState } from "react"
import {
  PopupContainer,
  PopupHeader,
  HeaderTitle,
  PopupContent,
  CloseDiv,
} from "./SettingsPopupStyles"
import { ReactComponent as CloseSVG } from "../../../lib/assets/icons/burger.svg"
import { GameBoardContext } from "../../../context/createContext"

export default function SettingsPopup({ title, children }: any) {
  const { settings, funcs } = useContext(GameBoardContext)
  const { handleSettingsSubpage, handleSettings } = funcs

  const popUpRef = useRef<any>(null)

  const [isOutside, setisOutside] = useState(false)

  const handleClickOutside = (event: any) => {
    if (popUpRef.current && !popUpRef.current.contains(event.target)) {
      setisOutside(true)
    }
  }

  useEffect(() => {
    if (settings.settingsSubpage !== "" && window.innerWidth > 767) {
      setisOutside(false)
      document.addEventListener("click", handleClickOutside, true)
    }
    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [settings.settingsSubpage])

  useEffect(() => {
    if (isOutside) {
      handleSettingsSubpage("")
    }
  }, [isOutside])
  return (
    <PopupContainer ref={popUpRef} className="popup">
      <PopupHeader>
        <HeaderTitle>{title}</HeaderTitle>
        <CloseDiv onClick={() => handleSettingsSubpage("")}>
          <CloseSVG />
        </CloseDiv>
      </PopupHeader>
      <PopupContent>{children}</PopupContent>
    </PopupContainer>
  )
}
